<template>
  <base-card body-class="pt-1">
    <template v-slot:body-top>
      <base-card-title class="mb-0" no-underline>Your Available Balance</base-card-title>
    </template>
    <div class="display-4 font-weight-bold">
      {{ totalBalance }}
    </div>
    <div class="mt-4 text-center">
      <base-button secondary :to="{ name: 'account.funds' }">
        Add Funds
      </base-button>
    </div>
  </base-card>
</template>

<script>
export default {
  name: 'UserAccountBalance',

  computed: {
    totalBalance () {
      return this.$formatting.toCurrency(
        this.$formatting.aggregateArrayAttribute(this.$auth.user.accounts, 'balance')
      )
    }
  }
}
</script>
